import styled, { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Catamaran', sans-serif;
  font-family: 'Josefin Sans', sans-serif ;
  font-family: 'Inter', sans-serif;
  font-family: 'Concert One', cursive;
  } 
 body
{
  overflow-x: hidden !important;
  font-family: 'Catamaran', sans-serif;
  font-family: 'Josefin Sans', sans-serif;
  font-family: 'Inter', sans-serif;
  font-family: 'Concert One', cursive;
}

iframe
{
  position: absolute !important;
  width: none !important;
  top: none !important;
  left: none !important;
  right: none !important;
  z-index: -5 !important;
}



 .updatedlinks {
    color: #032b88 !important;
  }




 /* Loader */
 .cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
 
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}


 
/* Models styles  */
.ant-modal-footer
  {
    display: none;
  }
  .ant-modal-close
  {
    display: none;
  }
  .ant-modal-content
  {
   background: none;
  }
  .ant-modal-body
  {
    padding: 0px;
  }
  .ant-modal-mask
  {
    background-color: rgb(0 0 0 / 78%) ;
  }
  .closeModelInput
  {
    transform: translateY(-2px);
  }
    .ant-space-align-baseline
  {
    display: flex;
    justify-content:center  ;
  }
  .modalInputMale
  {
    border-top-right-radius:7px;
  border-bottom-right-radius:7px;
  transform: translateX(-6px);
  }
  .ant-form-vertical .ant-form-item-label>label {
  
 
    font-weight:600;
}

  /* Models styles */

  .arrow
{
  position: fixed;
  bottom: 25px;
  right: 10px;
  z-index: 100;
  background: #032B88;
border-radius: 4px;
width: 32px;
height: 32px;
justify-content: center;
align-items: center;
text-align: center;
display: flex;
cursor: pointer;
}

.arrow-hidden
{
  display: none;
}




   
 
`;

export default GlobalStyle;
